/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface CommunityControllerDenyRequestToJoin$Params {
  id: number;
  request_id: number;
}

export function communityControllerDenyRequestToJoin(http: HttpClient, rootUrl: string, params: CommunityControllerDenyRequestToJoin$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, communityControllerDenyRequestToJoin.PATH, 'patch');
  if (params) {
    rb.path('id', params.id, {});
    rb.path('request_id', params.request_id, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

communityControllerDenyRequestToJoin.PATH = '/community/{id}/join/request/{request_id}/deny';
